import { defineAsyncComponent } from 'vue'
import { tabOutlineCalendarCheck } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { DrawerFeatureTwin, FeatureConfig } from 'src/models'
import { hasInvalidDigitalTwins } from 'src/utils/type-checks'

export interface EventsFeatureTwin extends DrawerFeatureTwin {
  modelId?: string
  relationshipName?: string
  color?: string
  noCreate?: boolean
  noEdit?: boolean
  noBlockEdit?: boolean // always editable if edit allowed
  supportsItems?: boolean
  itemsModelId?: string
  itemsRelationshipName?: string
  itemsLabel?: string
  itemsSublabel?: string
  itemsInlineCreate?: boolean
  hideContextMenu?: boolean
}

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./EventsFeatureDrawerMain.vue')),
    icon: tabOutlineCalendarCheck,
    label: 'Events',
    hide: hasInvalidDigitalTwins
  }
}

export default featureConfig
